import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

type AddCriteriaToSessionVariables = {
  sessionId: string;
  name: string;
  values: Record<string, string | number>;
};

async function addCriteriaToSessionRequest({
  sessionId,
  name,
  values,
}: AddCriteriaToSessionVariables) {
  const { data } = await api.post(
    `/sales-forecasting-sessions/${sessionId}/criteria`,
    {
      name,
      values,
    },
  );

  return data;
}

export const useAddCriteriaToSession = (
  options?: Omit<
    UseMutationOptions<void, Error, AddCriteriaToSessionVariables>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, AddCriteriaToSessionVariables> => {
  return useMutation({
    mutationFn: addCriteriaToSessionRequest,
    ...options,
  });
};
